import getDatesRange from "../../mixins/getDatesRange";

const DateRange = getDatesRange;

function getUpcomingEventsAmount(startDate, endDate, repeat, holidays = [], weekday = null) {
    const N = 86400000; // Milliseconds in a day
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set today to 00:00:00 for comparison

    let repeatType = repeat;

    if (startDate !== null) {
        const start = Date.parse(startDate);
        const end = Date.parse(endDate);

        if ((repeat === "none" || repeat === "no-repeat") && start !== end) {
            repeatType = "day";
        }

        const s = new Date(start);
        const e = new Date(end);
        s.setHours(0, 0, 0, 0);
        e.setHours(0, 0, 0, 0);

        let holidaysArray = holidays.map((h) => {
            if (h.oneDay) {
                return DateRange.methods.getDatesRange(new Date(h.start.plain), "", true);
            }
            return DateRange.methods.getDatesRange(
                new Date(h.start.plain),
                new Date(h.end.plain),
                true,
            );
        });

        holidaysArray = holidaysArray.flat();

        if (repeatType === "day") {
            const daysAmount = Math.round((end - start) / N) + 1;
            const validDays = [];
            for (let i = 0; i < daysAmount; i++) {
                const currentDay = new Date(start + i * N);
                if (currentDay > today && !holidaysArray.includes(currentDay.getTime())) {
                    validDays.push(currentDay);
                }
            }
            return validDays.length;
        }

        if (repeatType === "week") {
            let day = new Date(start).getDay();
            if (weekday) {
                const days = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
                day = days.findIndex((d) => d === weekday);
            }

            e.setDate(e.getDate() + 1);

            const daysOfWeek = [];
            while (s < e) {
                if (s.getDay() === day && holidaysArray.indexOf(s.getTime()) === -1 && s > today) {
                    daysOfWeek.push(s.getDay());
                }
                s.setDate(s.getDate() + 1);
            }

            return daysOfWeek.length;
        }

        if (repeatType === "month") {
            const eventsAmount = [];
            const firstDate = new Date(start).getDate();

            const datesRange = this.getDatesRange(s, e, true);

            datesRange.forEach((date) => {
                const currentDate = new Date(date);
                if (
                    currentDate.getDate() === firstDate &&
                    holidaysArray.indexOf(currentDate.getTime()) === -1 &&
                    currentDate > today
                ) {
                    eventsAmount.push(date);
                }
            });

            return eventsAmount.length;
        }

        if (repeatType === "no-repeat" || repeatType === "none") {
            return start > today ? 1 : 0;
        }
    }

    return "";
}

export default getUpcomingEventsAmount;